// src/guard/ProtectedRoute.js
import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { motion } from "framer-motion";
import { ShieldOff } from "lucide-react";

import { getFirstAllowedDashboardPath } from "../routes/dashboardPaths";

const ProtectedRoute = ({ module, children }) => {
  const location = useLocation();
  const isAuthenticated = Boolean(Cookies.get("authToken"));

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const allowedMenus = JSON.parse(localStorage.getItem("allowedMenus") || "[]");
  const isAllowed = !module || allowedMenus.includes(module);
  const fallbackPath = getFirstAllowedDashboardPath();

  if (!isAllowed) {
    return (
      <div className="w-full h-[70vh] flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          whileHover={{ scale: 1.01 }}
          transition={{ duration: 0.3 }}
          className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg border border-red-200 p-fluid-3 max-w-[clamp(18rem,30vw,26rem)] w-full"
        >
          <div className="flex flex-col items-center text-center gap-fluid-2">
            <ShieldOff className="w-fluid-icon-md h-fluid-icon-md text-Delete-red" />
            <h2 className="text-fluid-2xl font-bold text-Delete-red">
              Access Denied 🚫
            </h2>
            <p className="text-fluid-base text-gray-700">
              You do not have permission to access module: <strong className="text-Delete-red">{module}</strong>
            </p>
            {module === "claims" && (
              <p className="text-fluid-sm text-gray-600">
                Ask your admin to grant the <strong>claims:VIEW</strong> privilege, then log out and back in.
              </p>
            )}
            <a
              href={fallbackPath}
              className="text-blue-700 text-fluid-sm font-semibold hover:underline hover:text-blue-900 transition-colors"
            >
              ← Go back to dashboard
            </a>
          </div>
        </motion.div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
